<template>
  <div>
    <div>
      <Row class="expand-row">
        <Table
          :no-data-text="$t('common.noData')"
          :columns="columns"
          :data="securityData"
          style="width: 100%"
        ></Table>
      </Row>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    row: Object,
  },
  data() {
    return {
      columns: [
        {
          title: this.$t("RAM.GCP.Kubernetes.nodeName"),
          key: "name",
          render: (h, params) => {
            return h(
              "a",
              {
                style: {
                  textDecoration: "underline",
                },
              },
              params.row.name
            );
          },
        },
        {
          title: this.$t("RAM.GCP.Kubernetes.nodeLocations"),
          key: "locations",
        },
        {
          title: this.$t("RAM.GCP.Kubernetes.nodeMachineType"),
          key: "machineType",
        },
        {
          title: this.$t("RAM.GCP.Kubernetes.nodeDiskSize"),
          key: "diskType",
        },
        {
          title: this.$t("RAM.GCP.Kubernetes.nodeImageType"),
          key: "imageType",
        },
        {
          title: this.$t("RAM.GCP.Kubernetes.nodeDiskType"),
          key: "imageType",
        },
        {
          title: this.$t("RAM.GCP.Kubernetes.nodeInitialNodeCount"),
          key: "initialNodeCount",
        },
        {
          title: this.$t("RAM.GCP.Kubernetes.nodeVersion"),
          key: "version",
        },
        {
          title: this.$t("RAM.GCP.Kubernetes.nodeStatus"),
          key: "status",
        },
      ],
      securityData: this.row.resourceGcpGkeNodeDTOS,
    };
  },
};
</script>
<style scoped>
.expand-row {
  padding-left: 17px;
  margin-bottom: 10px;
}
.expand-key {
  width: 145px;
  display: block;
  float: left;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/resource_configuration_management/gcp/kubernetes/TableExpand.vue